module.exports = __webpack_public_path__ + "img/tire_scratch.0199b346.png";